import { useEffect, useState } from "react";

import { InitiativePost } from "../types";
import { fetchInitiativePosts } from "../services/initiativesService";

export const useInitiativePosts = () => {
  const [initiatives, setInitiatives] = useState<InitiativePost[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadInitiatives = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await fetchInitiativePosts();

        // sort so featured = true comes first
        const sorted = data.sort((a, b) => {
          if (a.is_featured === b.is_featured) return 0;
          return a.is_featured ? -1 : 1;
        });

        if (isMounted) {
          setInitiatives(sorted);
        }
      } catch (err) {
        console.error("Failed to load initiatives", err);
        if (isMounted) {
          setError(
            err instanceof Error ? err.message : "Failed to load initiatives"
          );
          setInitiatives([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadInitiatives();

    return () => {
      isMounted = false;
    };
  }, []);

  return { initiatives, loading, error };
};
